export default "__VITE_ASSET__CcJRWmiZ__"